export enum PaymentSettingOrderEnum {
    DepositWithOrder = 1,
    WithdrawalWithOrder = 2,
    DepositAndWithdrawalWithoutOrder = 3,
}
